import { render, staticRenderFns } from "./Topico.vue?vue&type=template&id=243a7579"
import script from "./Topico.vue?vue&type=script&lang=js"
export * from "./Topico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports